<script lang="ts">
    import {Autocomplete, type AutocompleteOption, popup, type PopupSettings} from '@skeletonlabs/skeleton';

    export let target: string;
  export let onChange: (() => Promise<void>) | undefined;
  export let options: AutocompleteOption<number>[] = [];
  export let timeout: number = 0;
  export let input: string;
  export let selectedValue: number | undefined = undefined;
  export let maxWidthClass: string = 'max-w-xs';
  export let onSelected: ((value: number, label: string) => void) | undefined = undefined;

  let popupSettings: PopupSettings = {
    event: 'focus-click',
    target: target,
    placement: 'bottom',
  };

  let timeoutId: number | undefined;

  function debounce(func: () => Promise<void>, wait: number) {
    return function (...args: any[]) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    };
  }

  const debouncedOnChange = debounce(async () => {
    if (onChange) {
      await onChange();
    }
  }, timeout);

  function onSelection(i) {
    selectedValue = i.detail.value;
    input = i.detail.label;
    onSelected?.(i.detail.value, i.detail.label);
  }
</script>

<input
  class="input {maxWidthClass}"
  type="search"
  name="demo"
  bind:value={input}
  placeholder="Search..."
  on:input={() => debouncedOnChange()}
  use:popup={popupSettings}
  autocomplete="off"
  aria-autocomplete="none"
/>
<div data-popup={target} class="card w-full {maxWidthClass} z-10 max-h-48 overflow-y-auto p-4" tabindex="-1">
  <Autocomplete bind:input {options} on:selection={onSelection} />
</div>
